import styled from 'styled-components';
import { Flex } from './Flex';
import { Label } from './Text';


const StyledRadioLabel = styled.label`
    padding: 0px 15px;
    border: 1px solid #E4EDFD;
    border-radius: ${({ placement }) => placement === "left" ? "8px 0px 0px 8px" : placement === "right" ? "0px 8px 8px 0px" : "0px"};
    height: 32px;
    border-right: ${({ placement }) => placement !== "right" && "none"};
    background: ${({checked}) => checked && "#f0f3fa"};
    display: flex;
    align-items: center;
    cursor: pointer;
    color: ${({checked}) => checked ? "var(--sp-main-color)" : "var(--sp-label-color)"};

    &:hover {
        border-color: #D2E1FC;
        color: var(--sp-main-color);
    }
`;

const StyledRadioButton = styled.input.attrs(({ checked, value, onChange }) => ({
    type: "radio",
    checked: checked,
    value: value,
    onChange: (e) => onChange(e.target.value)
}))`
    width: 0;
    height: 0;
`;

const RadioButton = ({ value, title, icon, onChange, ...props }) => (
    <StyledRadioLabel {...props}  onClick={(e) => {e.preventDefault(); onChange(value)}}>
        <StyledRadioButton value={value} checked={props.checked} />
        {title && <Label bold color={"currentColor"} hoverColor="red">{title}</Label>}
        {icon && icon}
    </StyledRadioLabel>
);

export const RadioButtonGroup = ({ buttons=[], value, onChange }) => {
    return(
        <Flex>
            {Array.isArray(buttons)
                ? buttons.map((button, idx) =>
                    <RadioButton
                        key={button.key}
                        value={button.key}
                        placement={idx === 0 ? "left" : idx === buttons.length-1 ? "right" : "middle"}
                        checked={button.key===value}
                        onChange={onChange}
                        {...button}
                    />)
                : null}
        </Flex>
    )
};